import { render, staticRenderFns } from "./billing-emails-note.vue?vue&type=template&id=350b4148"
import script from "./billing-emails-note.vue?vue&type=script&lang=js"
export * from "./billing-emails-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports